import { Event } from "../types/data";

export default [
    {
        key: "key1",
        hash: "hash-1",
        date: "2018-2021"
    },
    {
        key: "key2",
        hash: "hash-2",
        date: "2021-2024"
    },
    {
        key: "key3",
        hash: "hash-3",
        date: "2024-2025"
    }
] as Event[];
